import { configureStore } from '@reduxjs/toolkit';
import { setupListeners } from '@reduxjs/toolkit/query';

// project imports
import { baseApi } from './baseApi';
import authReducer from 'features/auth/authSlice';

export const store = configureStore({
  reducer: {
    auth: authReducer,
    [baseApi.reducerPath]: baseApi.reducer
  },
  middleware: (getDefaultMiddleware) =>
    getDefaultMiddleware({
      serializableCheck: {
        // La descarga de Excel del registro de actividad (US-009) resuelve su
        // mutación con un Blob (ver logsApi.js). RTK Query lo guarda en el
        // estado mientras dura esa mutación, pero nunca se serializa de verdad
        // (no hay persistencia); se ignora puntualmente esa forma, no todo el
        // chequeo, para no tapar problemas de serialización reales en el resto
        // del estado.
        ignoredActionPaths: [/\.blob$/],
        ignoredPaths: [/\.blob$/]
      }
    }).concat(baseApi.middleware)
});

// Enables refetchOnFocus / refetchOnReconnect for RTK Query hooks.
setupListeners(store.dispatch);

export default store;
